// @ts-nocheck

import R80834 from "./images/discounts-list.png";
import E27647 from "./images/improved_refunds.png";

const discounts_rules = () => (
  <>
    <p>
      <img src={R80834} alt="Discount rules" />
    </p>
    <p>
      Apply the new discounts rules to narrow your promotions audience. Set up conditions and
      channels that must be fulfilled to apply defined reward.
    </p>
  </>
);
const improved_refunds = () => (
  <>
    <p>
      <img src={E27647} alt="Improved refunds" />
    </p>
    <h3 id="enable-the-enhanced-refund-feature-to-streamline-your-refund-process">
      Enable the enhanced refund feature to streamline your refund process:
    </h3>
    <ul>
      <li>
        <p>
          • Choose between automatic calculations based on selected items or enter refund amounts
          directly for overcharges and custom adjustments.
        </p>
      </li>
      <li>
        <p>
          • Take advantage of separate permissions for drafting and finalizing refunds, enhancing
          control and security in the process.
        </p>
      </li>
    </ul>
  </>
);

export const AVAILABLE_FLAGS = [
  {
    name: "discounts_rules",
    displayName: "Discounts rules",
    component: discounts_rules,
    visible: true,
    content: {
      enabled: true,
      payload: "default",
    },
  },
  {
    name: "improved_refunds",
    displayName: "Improved refunds",
    component: improved_refunds,
    visible: true,
    content: {
      enabled: true,
      payload: "default",
    },
  },
] as const;
